/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Faq_Contact_Support_QuestionInputs */

const en_mobile_faq_contact_support_question = /** @type {(inputs: Mobile_Faq_Contact_Support_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to Contact Listening Support`)
};

const es_mobile_faq_contact_support_question = /** @type {(inputs: Mobile_Faq_Contact_Support_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cómo contactar al soporte de Listening`)
};

/**
* | output |
* | --- |
* | "How to Contact Listening Support" |
*
* @param {Mobile_Faq_Contact_Support_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_faq_contact_support_question = /** @type {((inputs?: Mobile_Faq_Contact_Support_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Faq_Contact_Support_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_faq_contact_support_question(inputs)
	return en_mobile_faq_contact_support_question(inputs)
});